import { getMobileStoreLink } from 'utils/mobileStoreRedirections';

export const Download = () => {
  window.location.href = getMobileStoreLink();
  return null;
};
